<template>
     <div class="row bg-light py-3">

        <div class="col-lg-12 col-md-12 col-sm-12">
        
            <div class="alert alert-info" v-for="item in list" :key="item.id">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <strong>{{ item.name }} : </strong> {{ item.description }} | <b>{{ item.date }}</b>
            </div>

        </div>

     </div>
</template>
<script>
import DocumentLibraryServices from "../../services/DocumentLibraryServices";
export default {
    data() {
        return {
            list: [],
            documentTypes: [],
            selectedID:0,
            Filters:{},
        }
    },

    created() {
        this.getDocumentTypes().then((response)=>{
            this.documentTypes = response.data.data;
            this.documentTypes.forEach((value) => {
                if(value.name === "Notices" || value.name === "notices"){
                    this.selectedID = value.id;
                    this.onFilter();
                }
            });
        });

    },

     methods: {

        async getDocumentTypes(){
            try{
                const responce = await DocumentLibraryServices.getDocumentsTypes();
                return responce;
            }catch (e) {
                return e;
            }
        },
        async getDocuments(obj){
            try {
                const responce = await DocumentLibraryServices.getDocuments(obj);
                return responce;
            } catch (e) {
                return e;
            }
        },

        onFilter(){
            this.Filters.typeID = this.selectedID;
            this.getDocuments(this.Filters).then((resp)=>{
                this.list = resp.data.data;
            });
        },
    
    }


}
</script>